import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstructTyped from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import OccurrenceForm from './OccurrenceForm';
import template from './OccurrenceFormDialog.html?raw';
// NOTE (JS2TS): dropped dead dep dojo/dom-attr (not used). xstyle/css!./OccurrenceHome.css was already commented out.
// DOM-heavy → dom-construct aliased.
const domConstruct: any = domConstructTyped;

class OccurrenceFormDialog extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    occurrenceGUID: any = null;

    occurrenceForm: any = null;
    //occurrenceList: null, // ist schon im Template
    _submitInProgess = false;
    employee: any = null;
    entity: any = null;
    _selectedFiltermode = "";//"MyOccurrences",
    _occurrenceFiltersInitialized = false;
    messageDialog: any = null;
    dlg: any = null;

    _isCancelAvailable = -3; // +1 wenn es ein Entity gibt;
    //+ 1 wenn Status es erlaubt;
    //+ 1 wenn das Entity "mir" gehört;
    //+ 1 wenn dort noch kein cancelrequest aktiv ist;
    //- 1 wenn dirty;
    // Ziel: 1 oder mehr

    startup(occurrenceGUID?: any, bReadOnly?: any, commentId?: any): void {
        super.startup.apply(this, arguments as any);

        this.dlg = new GenericDialog();
        this.dlg._setTopCloseBtnAttr(true);
        this.dlg._setCallbackAttr(lang.hitch(this, this._onClick_Modal_Close));

        /**
         * internalName: string,
    label: string,
    callback: Function,
    tooltip?: string,
    styleClass?: string,
    iconClass?: string,
    bCloseOnClick?: boolean,
    position?: "first" | "last" | "left first" | "left last" | number,
    enabled?: boolean
         *
         */
        this.dlg.addButton("submit",
            this.translate("OccurrenceHome__NewDialog_Submit"),
            lang.hitch(this, this._onClick_Submit),
            null,
            "primaryBG",
            null,
            false,
            "first",
            false
        );
        this.dlg.addButton("cancel",
            this.translate("OccurrenceForm__BtnCancelTicket"),
            lang.hitch(this, this._onClick_CancelTicket),
            null,
            "w3-red",
            null,
            false,
            "left first",
            false
        );

        this.occurrenceGUID = occurrenceGUID;
        this.showOccurrenceForm(occurrenceGUID, bReadOnly, commentId);
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    _setEmployeeAttr(value: any): void {
        this.employee = value;

        if (this.entity != null && this.employee != null) {
            if (this.entity.ref_reporter.ID == this.employee.ID) {
                this._isCancelAvailable++;
                console.debug("occurrenceformdlg employee", this.employee, this._isCancelAvailable);
                this.setCancelRequestBtnStyle();
            }
        }
    }

    _onLoadOccurrenceError(error: any): void {
        this.StandbyStop();
        this.showMessage(this.translations["OccurrenceFormDialog__ErrorLoading"], error.Message, null, lang.hitch(this, "_onClick_Modal_Close"));
        //alert(error.message);
    }

    showOccurrenceForm(occurrenceGUID?: any, bReadOnly?: any, commentId?: any): void {
        console.log("showOccurrenceForm", occurrenceGUID);
        if (this.occurrenceForm == null) {
            this.occurrenceForm = new OccurrenceForm();
            this.dlg.show();

            //new Moveable(this.modalWindow, { handle: this.headerNode });

            //this.occurrenceForm.itemID = this.item.ref_associate;
            this.occurrenceForm.employee = this.employee;

            this.occurrenceForm.errorCallback = lang.hitch(this, "_onOccurrenceFormError");


            this.dlg.addNodeToContent(this.occurrenceForm.domNode);
            //domConstruct.place(this.occurrenceForm.domNode, this.modalContentNode);

            on(this.occurrenceForm, "EntityChange", lang.hitch(this, "onChange_Entity"));
            this.onChange_Entity();

            if (occurrenceGUID != null && typeof (occurrenceGUID) != "undefined") {
                this.occurrenceForm.entityGUID = occurrenceGUID;
                this.dlg._setHeaderAttr(this.translate("OccurrenceHome__NewDialog_HeaderEdit"));

                this.setUrlParameter("view", occurrenceGUID);
            }

            this.onChange_DirtyState(false);

            if (true) {//bReadOnly != true) {
                on(this.occurrenceForm, "DirtyStateChange", lang.hitch(this, "onChange_DirtyState"));
            }
            this.occurrenceForm.startup();

            if (bReadOnly === false || bReadOnly === true) {
                this.occurrenceForm.set("Readonly", bReadOnly);
            }



            if (typeof (commentId) == "string") {
                this.occurrenceForm.showComment(commentId);
            } else {
                //var occHome = document.occurrenceHome;
                //occHome.siteActionReset("view?id=" + occurrenceGUID);
            }
        }

    }

    onChange_Entity(jsonEntity?: any): void {
        this.entity = jsonEntity;

        if (typeof (jsonEntity) == "undefined" || jsonEntity == null) {
            this.dlg._setHeaderAttr(this.translate("OccurrenceHome__NewDialog_Header"));
            this.dlg.setGlow("#00000077");

            this.dlg.removeButton("reload");
        }

        else {
            let formattedNumber = domConstruct.create("span", {
                innerHTML: jsonEntity.Number,
                className: "bold tertiaryBG secondaryOutline round paddingSmall"
            });

            this.dlg._setHeaderAttr(this.translate("OccurrenceHome__EditDialog_Header").format(formattedNumber.outerHTML, jsonEntity.ref_occurrence_status.description));

            this.dlg.setGlow(jsonEntity.ref_occurrence_status.hexColor + "88");
            //domClass.remove(this.headerBtnReload, "w3-hide");

            this.dlg.addButton("reload",
                null,
                lang.hitch(this, this._onClick_Modal_Reload),
                this.translate("General_Reload"),
                null,
                "fas fa-sync",
                false,
                "top"
            );

            if (this.employee != null) {
                if (jsonEntity.ref_reporter.ID == this.employee.ID) {
                    this._isCancelAvailable++;
                }
            }

            if (jsonEntity.ref_occurrence_status.is_cancel_request_enabled == true) {
                this._isCancelAvailable++;
            }

            if (jsonEntity.is_cancellation_requested != true) {
                this._isCancelAvailable++;
            }

            //console.debug("occurrenceformdlg entity", jsonEntity, this._isCancelAvailable, this.employee);

            this.setCancelRequestBtnStyle();
        }
    }

    setCancelRequestBtnStyle(): void {
        this.dlg.enableButton("cancel", this._isCancelAvailable >= 1);

        var fct1: any = domClass.add;
        var fct2: any = domClass.remove;



        if (this._isCancelAvailable >= 1) {
            fct1 = domClass.remove;
            fct2 = domClass.add;
        }

        fct1(this.btn_cancelTicket, "w3-disabled");
        fct2(this.btn_cancelTicket, "w3-red mds-hover-bright");
    }

    onChange_DirtyState(state?: any): void {
        console.log("new dirtystate: ", state);

        this.dlg.enableButton("submit", state === true);

        if (state === true) {
            domClass.add(this.btn_submit, "accentcolor mds-hover-bright");
            domClass.remove(this.btn_submit, "w3-disabled");
            this._isCancelAvailable--;
        } else {
            domClass.remove(this.btn_submit, "accentcolor mds-hover-bright");
            domClass.add(this.btn_submit, "w3-disabled");
            this._isCancelAvailable++;
        }

        this.setCancelRequestBtnStyle();
    }

    _onClick_CancelTicket(evt?: any): void {

        if (this._isCancelAvailable < 1) return;

        var dialog: any = new GenericDialog;

        domStyle.set(dialog.textNode, "height", "unset");
        dialog.destroyOnClose = false;

        dialog.set("header", this.translations["OccurrenceForm__DialogCancelTicketHeader"].format(this.entity.Number));//taskEntity.Number + " erledigen");
        //dialog.set("SubTitle", "Die Ausführung zu Auftrag " + taskEntity.Number + " wird erledigt und eine Nachricht an den Meldenden geschickt.<br>Möchten Sie eine Anmerkung hinzufügen?");
        dialog.set("SubTitle", this.translations["OccurrenceForm__DialogCancelTicketSubtitle"].format(this.entity.Number, this.entity.ref_reporter.DispName));

        dialog.set("ok", true);
        dialog.set("cancel", true);
        //dialog.set("content", "Hier Freitexteingabe");

        var input = domConstruct.create("textarea");
        domClass.add(input, "w3-input w3-block");
        dialog.addNodeToContent(input);
        //domAttr.set(input, "placeholder", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_NotesPlaceholder"]);//"Anmerkungen?");

        // verhinden dass mit "Enter" der Dialog beendet wird
        on(input, "keyup", function (evt: any) {
            evt.stopPropagation();
        });

        dialog.set("callback", lang.hitch(this, "_onCancelTicketDlgResponse", input, dialog));

        dialog.show();

    }

    _onCancelTicketDlgResponse(input: any, dialog: any, response?: any): void {
        console.log("_onCancelTicketDlgResponse", input, dialog, response);

        if (response == 1) {
            var stringParams = JSON.stringify({
                note: input.value,
                occurrenceGUID: this.occurrenceGUID,
                "cancellationRequested": true // this.is_cancellation_requested != true // inzwischen mal nicht rückgängig machbar

            });
            var url = window.appRoot + "JDM/RequestCancellation";

            this._request = this.RequestManager.post(
                url,
                {
                    jsonData: stringParams,
                },
                lang.hitch(this, "_onRequestCancelTicketResponse", dialog),
                lang.hitch(this, "_onRequestCancelTicketError"),
                false // sync
            );
        }
    }

    _onRequestCancelTicketResponse(response?: any): void {
        this._isCancelAvailable = -10;
        this.occurrenceForm.startup(true);
    }

    _onRequestCancelTicketError(error: any): void {
        console.error("_onRequestCancelTicketError", error);
        this.showMessage(this.translations["OccurrenceFormDialog__ErrorCancelTicket"], error.Message, null, null);// lang.hitch(this, "_onClick_Modal_Close"));

    }

    _onClick_Submit(evt?: any): void {

        if (this._submitInProgess === true || this.occurrenceForm.isDirty != true) {
            return;
        }

        if (this.occurrenceForm.isSpecialConfirmationNeeded === true && this.occurrenceForm._specialConfirmationStatus != true) {
            this._onOccurrenceFormError(this.translations["OccurrenceForm__Submit_SpecialConfirmationNeeded"]);
            return;
        }

        this._submitInProgess = true;

        var bIsNew = this.occurrenceForm.entityID == null;

        this._onOccurrenceFormError(null);
        this.dlg.disableButton("submit");
        this.occurrenceForm.saveOccurrenceData(lang.hitch(this, "_onSubmitNewOccurrenceResponse", bIsNew));
        //this._onClick_Modal_Close(evt);
    }

    _onSubmitNewOccurrenceResponse(bIsNew: any, response?: any): void {
        //console.log("_onSubmitNewOccurrenceResponse", this.domNode);

        this.emit("EntitySaved");

        if (bIsNew === true) {
            this.showMessage(this.translations["OccurrenceHome__NewEntitySavedHeading"], this.translations["OccurrenceHome__NewEntitySavedConfirmation"], null, lang.hitch(this, "_onClick_Modal_Close")); //"Meldung wurde aufgenommen / Thanks for your request", "Your request has been successfully submitted!"
        } else {
            this._onClick_Modal_Close();
        }
    }

    _onClick_Modal_Close(evt?: any): void {

        this.emit("OccurrenceFormClosed");

        //domConstruct.destroy(this.occurrenceForm.domNode); // optional?

        this.occurrenceForm = null;
        if (this.dlg) {
            this.dlg.close(-1, true);
        }
        this.destroy();
    }

    _onClick_Modal_Reload(evt?: any): void {
        this._isCancelAvailable = -3;
        this.set("Employee", this.employee);
        this.occurrenceForm.startup(true);
    }

    _onOccurrenceFormError(message?: any): void {
        this._submitInProgess = false;
        if (message) {
            alert(message);
            this.dlg.enableButton("submit");

        }
        //domAttr.set(this.errorMsgNode, "innerHTML", message);
    }

    showMessage(header: any, message: any, subtitle?: any, callback?: any): void {
        var dialog: any = new GenericDialog();

        if (typeof (subtitle) == "string") {
            dialog.set("subtitle", subtitle);
        } else {
            dialog.hideSubtitleNode();
        }

        this.messageDialog = dialog;
        domStyle.set(dialog.textNode, "height", "unset");

        dialog.set("header", header);
        dialog.set("content", message);
        dialog.set("callback", lang.hitch(this, "showMessageCallback", callback));

        dialog.set("ok", true);
        //dialog.set("cancel", true);

        dialog.show();
    }

    showMessageCallback(callback?: any): void {
        if (typeof (callback) == "function") {
            callback();
        }

        this.messageDialog = null;
    }
}
OccurrenceFormDialog.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.OccurrenceFormDialog';

export default mdsWidget(OccurrenceFormDialog);
